<script>
import { nextTick } from 'vue';
import { updateAWin, getAllWinsForTodayFromDbase, deleteAWin, deleteAllOfTodaysWins } from '@/services/WinsServices';

export default {
  props: [ 'propTodaysWins' ],
  data() {
    return {
      todaysWins: [],
      modalResetTodaysWins: false,
    };
  },
  computed: {
    uId() { return this.$store.getters['uId']; },
    token() { return this.$store.getters['token']; },
    today() { return this.$store.getters['today']; },
    todayActual() { return this.$store.getters['todayActual']; },
    program() { return this.$store.getters['program']; },
    pIds() {
      let ids = [];
      for (let p in this.program) {
        ids.push(this.program[p].id);
      }
      return ids;
    },

  },
  methods: {
    async stackWin(win, stackedStatus) {
      const didItUpdate = await updateAWin(this.uId, this.token, this.today, this.todayActual, win, stackedStatus);
      if (didItUpdate) {
        this.todaysWins = await getAllWinsForTodayFromDbase(this.uId, this.token, this.today);
      }
    },
    async deleteWin(wId) {
      const deleteSuccessful = await deleteAWin(this.uId, this.token, this.today, wId);
      if (deleteSuccessful) {
        // update front end
        const todaysWins = await getAllWinsForTodayFromDbase(this.uId, this.token, this.today);
        this.$store.dispatch('program/todaysWins', todaysWins);
      }
    },

    editProgram() {
      this.$cookies.set('lastViewedTab', 'program');
      this.$router.push('/account');
    },
    async resetTodaysProgramWins() {
      this.modalResetTodaysWins = true;
    },
    async forrealForrealResetTodaysProgramWins() {
      await deleteAllOfTodaysWins(this.uId, this.token, this.today);

      await nextTick();
      window.location.reload();
    },
  },
  created() {
    this.todaysWins = [ ...this.propTodaysWins ];
  },
};
</script>

<template>
  <div class="mb-5">

    <!-- IF USER HAS TODAYWINS -->
    <div v-if="todaysWins && todaysWins.length">

      <p class="text-right text-body-2 text-red-lighten-2">
        <i @click="editProgram">Edit my Morning/Wake-Up Routine</i>
      </p>

      <v-card v-for="win in todaysWins"
        :key="win.id"
        :id="win.id"
        class="d-flex mt-6"
        variant="flat"
      >
        <v-icon v-if="!!win.stacked"
          class="mr-2"
          @click.prevent="stackWin(win, false)"
        >
          mdi-checkbox-marked-outline
        </v-icon>
        <v-icon v-else
          class="mr-2"
          @click.prevent="stackWin(win, true)"
        >
          mdi-checkbox-blank-outline
        </v-icon>
        <div class="w-100">
          <p class="one-win-text" :class="win.stacked ? 'text-decoration-line-through' : ''">{{ win.win }}</p>
          <p v-if="pIds && !pIds.includes(win.programId)" class="text-right text-red text-caption mb-0 pb-0" @click.prevent="deleteWin(win.id)">delete</p>
        </div>
      </v-card>

      <p class="mt-5 pt-3 text-body-2 text-red-lighten-2">
        <i @click.prevent="resetTodaysProgramWins">Reset today's wins</i>
      </p>

    </div>

    <!-- IF USER DOES NOT HAVE A PROGRAM -->
    <div v-else-if="!program.length"
      id="no-wins-in-program"
      class="pa-5 border"
    >
      <h3 class="font-weight-bold">Nobody set up us the Daily Program</h3>
      <v-btn @click.prevent="editProgram"
             color="blue-lighten-1"
             class="mt-5"
             density="comfortable"
      >Add Wins to Your Program Now</v-btn>
    </div>

    <!-- IF USER HAS A PROGRAM, BUT NO WINS FOR TODAY -->
    <div v-else-if="program.length && !todaysWins.length"
         class="yes-program-no-wins py-5 text-center mx-auto"
    >
      <p>This Dashboard is for another day, not today (check the date at the top of the screen).</p>
      <p class="mt-6 mb-2 font-italic">Would you like to pre-create and see the Daily Wins for this day anyway?</p>
      <v-btn @click.prevent="$emit('create-wins-for-not-today-actual')"
             color="blue-lighten-1"
             class="text-lowercase"
             density="comfortable"
      >Create Wins for this day anyway</v-btn>

    </div>

  </div>

  <!-- MODAL: RESET TODAY'S WINS -->
  <v-dialog v-model="modalResetTodaysWins" max-width="800">
    <v-card title="Reset Today's Wins?">

      <v-card-text class="my-5">
        Resetting today's wins will cause you to lose all your progress and wins stacked status. It will reset to a fresh day.
      </v-card-text>

      <template v-slot:actions>
        <v-btn @click="modalResetTodaysWins = false"
               color="grey-darken-2"
               class="me-auto"
               variant="outlined"
        >Cancel</v-btn>
        <v-btn @click.prevent="forrealForrealResetTodaysProgramWins"
               color="red-lighten-2"
               class="ms-auto"
               variant="outlined"
        >Reset Today's Wins Forreal</v-btn>
      </template>
    </v-card>
  </v-dialog>

</template>

<style lang="scss" scoped>
i:hover { cursor: pointer; }
.one-win-text { white-space: pre-line; }
.yes-program-no-wins {
  @media screen and (min-width: 768px) {
    width: 75%;
  }
}
</style>
